import type {
  Direction,
  LogicalAlignment,
  PhysicalAlignment,
} from '@wix/editor-elements-common-utils';
import { castFromInheritIfNeeded } from '@wix/editor-elements-common-utils';
import type {
  RichTextBoxDefinition,
  RichTextBoxStyleProperties,
} from '../../RichTextBox.types';

const convertLogicalAlignmentToPhysical = (
  logicalAlignment: LogicalAlignment,
  direction: Direction,
): PhysicalAlignment => {
  if (logicalAlignment === 'center') {
    return 'center';
  }

  if (
    (logicalAlignment === 'start' && direction === 'ltr') ||
    (logicalAlignment === 'end' && direction === 'rtl')
  ) {
    return 'left';
  } else {
    return 'right';
  }
};

export const getDirection = (compData: RichTextBoxDefinition['data']) => {
  return castFromInheritIfNeeded(compData.direction, 'ltr');
};

export const getPhysicalInputAlignment = (
  compData: RichTextBoxDefinition['data'],
  styleProperties: RichTextBoxStyleProperties,
) => {
  const { align, inputAlign } = styleProperties;
  const { inputDirection } = compData;

  const direction = getDirection(compData);

  const computedInputALign = castFromInheritIfNeeded(inputAlign, align);

  const computedInputDirection = castFromInheritIfNeeded(
    inputDirection,
    direction,
  );
  const physicalAlignment = convertLogicalAlignmentToPhysical(
    computedInputALign,
    computedInputDirection,
  );

  return physicalAlignment;
};
